module.exports = __webpack_public_path__ + "logo_en.png?f485ee20956c93a04158b811eda7bb4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_en.png
// module id = 220
// module chunks = 0